import _slicedToArray from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// ignore-string-externalization
import React from 'react';
import Router, { useRouter } from 'next/router';
import storage from 'local-storage-fallback';
import { useCurrentUser } from '../../@mrkt/useCurrentUser';
import { Wait } from '../Layout/Wait';
import { jsx as _jsx } from "react/jsx-runtime";
export var LoggedInRedirect = function LoggedInRedirect(_ref) {
  var children = _ref.children,
      activeSession = _ref.activeSession;
  var router = useRouter();
  var doCheck = activeSession && Object.keys(router.query).length === 0;

  var _React$useState = React.useState(doCheck),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var user = useCurrentUser();
  React.useEffect(function () {
    if (!doCheck || user === undefined) {
      return;
    }

    var redirectedKey = "".concat(user === null || user === void 0 ? void 0 : user.username, ":analytics:loggedInRedirect");

    if (user !== null && user !== void 0 && user.hasAccess) {
      storage.setItem(redirectedKey, 'true');
      Router.push('/c');
    } else {
      storage.removeItem(redirectedKey);
      setLoading(false);
    }
  }, [user]);
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "logged-in-redirect",
    children: !loading && children || /*#__PURE__*/_jsx(Wait, {
      cover: true
    })
  });
};